exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav__toggle[data-v-15a9ba83]{padding:0}", ""]);

// exports
